import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[wlReceiptBreakdown]',
  standalone: true,
})
export class ReceiptBreakdownDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
